import { render, staticRenderFns } from "./TodoForm.vue?vue&type=template&id=5f1940f2&scoped=true"
import script from "./TodoForm.vue?vue&type=script&lang=js"
export * from "./TodoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1940f2",
  null
  
)

export default component.exports